import "@angular/compiler";
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installGoogleIdentityStub } from './app/shared/helpers/google-identity';

if (environment.production) {
  enableProdMode();
}

var html = document.documentElement.innerHTML;
const span = document.createElement('span');
span.innerHTML = environment.projectName;
var projName =  span.textContent || span.innerText;
document.documentElement.innerHTML = html.replace("...",projName);

// login components call google.accounts.id.*; the Google script loads only for a configured client id
installGoogleIdentityStub();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
